<div class="main-container">
	<img
		class="__image"
		src="assets/images/logo_gobernacion.svg"
		alt="Logo Gobernación Valle del Cauca"
	/>
	<img
		class="__image"
		src="assets/images/logo_dnp.svg"
		alt="Logo Departamento Nacional de Planeación"
	/>
	<img
		class="__image"
		src="assets/images/logo_sgr.svg"
		alt="Logo Sistema General de Regalías"
	/>
</div>
